import { useState } from 'react'
import { PluginFrame } from './PluginFrame.tsx'
import { rotuloDaExtensao, useExtensoesInstaladas } from './useExtensoes.ts'

/**
 * As seções que os plugins acrescentam ao Item de Trabalho
 * (SPEC-20260926-2036-plugin-painel-no-item).
 *
 * Uma seção por extensão `work-item-panel` instalada, no mesmo formato visual
 * das seções nativas (cabeçalho com seta, corpo recolhível).
 *
 * Duas decisões que valem registrar:
 *
 * - **Nascem RECOLHIDAS.** Abrir o Item não pode disparar uma chamada a cada
 *   serviço de terceiro instalado — seriam N requisições a hosts que não
 *   controlamos, no caminho mais quente do produto. O iframe só monta quando
 *   alguém abre a seção.
 * - **Não atrasam nada.** Se a consulta das extensões ainda não voltou, não há
 *   seção; quando voltar, elas aparecem. O Item nunca espera por plugin.
 */
export function PaineisDePlugin({
  workItemId,
  ligado,
  onRecarregarItem,
}: {
  workItemId: string
  /** O módulo de plugins está no plano deste workspace? */
  ligado: boolean
  onRecarregarItem?: () => void
}) {
  const extensoes = useExtensoesInstaladas('work-item-panel', ligado).data ?? []
  const [abertas, setAbertas] = useState<readonly string[]>([])

  if (extensoes.length === 0) return null

  return (
    <>
      {extensoes.map((e) => {
        const id = `${e.pluginKey}:${e.chave}`
        const aberta = abertas.includes(id)
        return (
          <div key={id} className="wi-sec">
            <button
              type="button"
              className="wi-sec__head"
              aria-expanded={aberta}
              onClick={() =>
                setAbertas((atual) => (aberta ? atual.filter((x) => x !== id) : [...atual, id]))
              }
            >
              <i className={`fas fa-chevron-${aberta ? 'down' : 'right'} wi-sec__chev`} aria-hidden />
              <i className={e.config.icon ?? 'fas fa-plug'} aria-hidden />
              <span className="wi-sec__title">{rotuloDaExtensao(e)}</span>
              {/* de quem é isto: numa lista de seções nativas, a origem
                  precisa estar à vista */}
              <span className="wi-sec__meta">plugin · {e.pluginKey}</span>
            </button>

            {aberta ? (
              <div className="wi-sec__body">
                <PluginFrame
                  tipo="work-item-panel"
                  chave={e.chave}
                  workItemId={workItemId}
                  encaixe="conteudo"
                  onFechar={() => setAbertas((atual) => atual.filter((x) => x !== id))}
                  onRecarregarItem={onRecarregarItem}
                />
              </div>
            ) : null}
          </div>
        )
      })}
    </>
  )
}
